import { useContext } from 'react'

import { TypedNodeContext } from './context'

import type { TypedNode } from '@rehaje/core'

/**
 * 获取当前渲染的 TypedNode 节点
 */
export function useTypedNode<T extends TypedNode = TypedNode>(): T | undefined {
  return useContext(TypedNodeContext) as T | undefined
}
